precision lowp float;

uniform sampler2D tMap;
uniform sampler2D tNoise;
uniform vec3 uColor;
uniform float uAmount;

varying vec2 vUv;

vec4 fbm(vec2 v) {
    float t = 0.;
    vec4 n = vec4(0.);
    float b = 1./32.;
    for (float s = 1.; s > b; s *= 0.5) {
        t += s;
    	n += texture2D(tNoise, b / s * v) * s;
    }
    return n / t;
}

void main(){
  vec4 n = fbm(vUv * 3.);
  vec2 m = pow(abs(vec2(n.r - n.b, n.g - n.a)) * 3., vec2(.5));

  gl_FragColor =  vec4((1. - (1. - m.x) * (1. - m.y)) * .6 + .3);
  gl_FragColor.rgb = mix(gl_FragColor.rgb, uColor, uAmount);
  gl_FragColor.a = 1.;
}